import JQueryView, { on } from '../../../common/views/jqueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('.index');
  }

  @on({ event: 'click', selector: 'tr.link-row' })
  onClickLinkCell(event: JQuery.ClickEvent) {
    const id = event.currentTarget.dataset.id;
    window.location.href = `/plus/projects/${id}`;
  }
}
